import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "infoboard-description" }
const _hoisted_2 = { class: "infoboard-description__title g-text g-text--l" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "g-container g-container--no-top-border g-container--pass-padding" }
const _hoisted_5 = { class: "infoboard-description__number g-text g-text--center g-text--3xl g-text--center" }
const _hoisted_6 = { class: "g-text--xl" }
const _hoisted_7 = { class: "g-text g-text--m" }
const _hoisted_8 = { class: "no-reference-text" }
const _hoisted_9 = {
  key: 0,
  ref: "text",
  class: "g-container g-container--no-top-border g-container--pass-padding"
}
const _hoisted_10 = { class: "g-text g-text--title g-text--m" }
const _hoisted_11 = { class: "g-text g-text--m" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_CountUp = _resolveComponent("CountUp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.computedSaving), 1),
      (_ctx.computedAnimatedFlip)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["g-flip-card g-text g-text--xl g-margin--0", {'g-flip-card--flip': _ctx.rotation.isProduction ? !_ctx.rotation.description.savings : _ctx.rotation.description.savings}])
          }, [
            _createVNode(_component_FontAwesomeIcon, { icon: ['fal', 'exclamation-circle'] }),
            _createVNode(_component_FontAwesomeIcon, { icon: ['fal', 'check-circle'] })
          ], 2))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, [
            (_ctx.rotation.isProduction ? !_ctx.rotation.description.savings : _ctx.rotation.description.savings)
              ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                  key: 0,
                  icon: ['fal', 'check-circle']
                }))
              : (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                  key: 1,
                  icon: ['fal', 'exclamation-circle']
                }))
          ]))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createBlock(_component_CountUp, {
          class: "g-width--full",
          key: _ctx.computedUnit,
          counter: Math.abs(_ctx.rotation.description.changes.value),
          formatter: _ctx.computedCountUpFormatter
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.computedUnit), 1)
          ]),
          _: 1
        }, 8, ["counter", "formatter"]))
      ]),
      _createElementVNode("small", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.$t(`sharedTexts.comparisons.${_ctx.rotation.comparison}.${_ctx.rotation.resolution}.comparisonDescription`)) + " ", 1),
        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("small", _hoisted_8, _toDisplayString(_ctx.computedHasNoReferenceData ? _ctx.$t('sharedTexts.NoReferenceData') : ''), 1)
      ])
    ]),
    (_ctx.computedEqualTo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t('sharedTexts.funFact')), 1),
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.computedEqualTo), 1)
        ], 512))
      : _createCommentVNode("", true)
  ]))
}